export default {
      id: "mmenu-close-usage",
      viewBox: "0 0 28 29",
      url: __webpack_public_path__ + "app/svg/sprite.svg#mmenu-close",
      toString: function () {
        return this.url;
      }
    }